import { User } from '@choco-admin/types';
import { Card, CardBody, CardHeader } from '@heroui/react';
import React from 'react';

import { UserForm } from '../../UserForm';
import { UserFormData } from '../../UserForm/hooks/useUserFormValidation';
import { UserFormChangedFields } from '../../UserForm/utils/changedFields';

interface UserEditFormProps {
  initialFormData: Partial<UserFormData>;
  onSubmit: (
    values: UserFormData,
    changedFields: UserFormChangedFields
  ) => Promise<void>;
  isSubmitting: boolean;
  user: User;
  disabled?: boolean;
}

export const UserEditForm: React.FC<UserEditFormProps> = ({
  initialFormData,
  onSubmit,
  isSubmitting,
  user,
  disabled = false,
}) => {
  return (
    <Card className="bg-content1 border-default-200">
      <CardHeader>
        <h2 className="text-xl font-semibold text-foreground">
          {disabled ? 'User Information (Read Only)' : 'Edit User Information'}
        </h2>
      </CardHeader>
      <CardBody>
        <UserForm
          initialData={initialFormData}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          submitLabel="Update User"
          isEditMode={true}
          user={{
            id: user.id,
            name: user.name,
            // uploadUrl is present even for a user with no picture yet — it
            // is the presigned PUT target for the first upload, so it must
            // be threaded through independently of whether a url exists.
            profileImage:
              user.profileImageUrl || user.profileImageUploadUrl
                ? {
                    url: user.profileImageUrl,
                    uploadUrl: user.profileImageUploadUrl,
                    mediumSquare: user.profileImageMediumSquare,
                  }
                : null,
            isPuppy: user.isPuppy,
            createdContext: user.createdContext,
            supplier: user.supplier,
            supplierId: user.supplierId,
            supplierName: user.supplierName,
            supplierReferenceId: user.supplierReferenceId,
            supplierRole: user.supplierRole,
          }}
          userBuyers={user?.linkedBuyers || []}
          disabled={disabled}
        />
      </CardBody>
    </Card>
  );
};
